module.exports = __webpack_public_path__ + "static/media/IRRESISTIBLE_GRIS.e43eb9f1.jpg";